import { createBooleanTagManager } from '../../utils/createBooleanTagManager';

export const furnitureTagManager = createBooleanTagManager({
  jsonQueryKey: 'has_furniture',
  trueLabel: 'С мебелью',
  falseLabel: 'Без мебели',
  id: 'furniture',
});
